<ul class="filter-ui">
    <li class="filter-li" *ngFor="let option of uniqueValues">
    <input type="checkbox" [(ngModel)]="selectedValues[option]" (change)="onSelectionChange()">
    <label style="padding-left: .5rem;">{{ option }}</label>
    </li>
</ul>